import { mapGetters } from 'vuex'

export default {
  watch: {
    async id (newId) {
      if (!newId)
        return

      await this.load(newId)

      if (this.pageTitle)
        this.$root.setMetaTitle(this.pageTitle)
    }
  },
  async mounted () {
    if (!this.id)
      return

    await this.load(this.id)

    if (this.pageTitle)
      this.$root.setMetaTitle(this.pageTitle)
  }
}
